import React from "react";
import {Flex, View} from "@adobe/react-spectrum";

function PhoneSectionHeader() {
    return (
        <View padding="size-250" paddingBottom={0}>
            <Flex direction="column" alignItems="start" gap="size-200">
                <p className="fs-24 bold">20,000+ fonts at your <em>fingertips</em></p>
                <p className="fs-16"><strong>Type your text, use the joystick, and surprise yourself with amazing fonts</strong></p>
                <a className="fs-16" href="#about">More about this prototype</a>
            </Flex>
        </View>
    );
}

export default PhoneSectionHeader;